import { render, staticRenderFns } from "./MenuMgtView.vue?vue&type=template&id=f4ee5b18&scoped=true&"
import script from "./MenuMgtView.vue?vue&type=script&lang=js&"
export * from "./MenuMgtView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ee5b18",
  null
  
)

export default component.exports